<script lang="ts">
    import type { Agenda } from '../types/agenda';
    
    const { item } = $props<{ item: Agenda }>();
</script>

<article class="px-4 py-2 text-xl flex max-sm:flex-col {(item.break >= 0 ? 'bg-indigo-200/15' : '')}" >
    <h3 class="text-indigo-300 whitespace-nowrap mr-8 max-sm:mb-4">{item.time}</h3>
    <div>
        <p class="font-bold {(item.break >= 0 ? 'text-indigo-200' : '')}">
            {item.topic}
        </p>
        {#if Array.isArray(item.details) }
            {#each item.details as i}
                <article class="my-4">
                    <p class="text-cyan-400">{i.topic}</p>
                    <p>{@html i.details}</p>
                </article>
            {/each}
        {:else if item.details}
            <p>{item.details}</p>
        {/if}
    </div>
</article>

<style></style>